module.exports = __webpack_public_path__ + "img/hourglass-icon.dbf62b70.svg";